<template>
  <div class="content">
    <div class="top">
      <div class="upload-item">
        <input
            id="uploaderInputSecond"
            class="input uploaderInputSecond"
            v-if="!isPc"
            type="file"
            accept="image/*"
            @change="showPositiveImage"
          />
        <div class="pic">
          <img
            :src="positive"
            v-if="positive"
          />
          <img v-else src="@/assets/images/positive.png" alt="" class="background">
        </div>
        <div class="tip">点击上传人像面</div>
      </div>
      <div class="upload-item">
        <input
            id="uploaderInputFirst"
            class="input uploaderInputFirst"
            v-if="!isPc"
            type="file"
            accept="image/*"
            @change="showNegativeImage"
          />
        <div class="pic">
          <img
            :src="negative"
            v-if="negative"
          />
          <img v-else src="@/assets/images/back.png" alt="" class="background">
        </div>
        <div class="tip">点击上传国徽面</div>
      </div>
    </div>
    <div class="info">
      <van-cell v-for="item in infoFields" :key="item.label" :title="item.title" :value="infoObj[item.label]" />
    </div>
    <div class="fix-btm">
      <Button
        :disabled="btnDisabled"
        text="下一步"
        type="danger"
        class="nextStep"
        :click='nextStep'
      />
    </div>
    
  </div>
</template>
<script>
// import { stringify } from 'querystring';
import Button from '@/components/Button.vue';
import { Toast } from 'vant';
import service from '@/request/api'; // 导入api接口
import ServerBank from '@/components/ServerBank.vue';
import { checkStatus } from './mixin';

export default {
  name: 'idCardRecognition',
  components: {
    Button
  },
  data() {
    return {
      positive: '',
      idFrontPic: '',
      negative: '',
      idBackPic: '',
      isDisabled: false,
      isPc: false,
      infoFields: [
        { title: "姓名", label: "name" },
        { title: "身份证号", label: "idNumber" },
        { title: "性别", label: "sex" },
        { title: "民族", label: "people" },
        { title: "户籍地址", label: "address" },
        { title: "签发机关", label: "issueAuthority" },
        { title: "签发日期", label: "expirationDateStart" },
        { title: "失效日期", label: "expirationDateEnd" },
        // { title: "有效期限", label: "validDate" },
      ],
      infoObj:{},
      btnDisabled: true, // 初始化按钮为禁用状态
    };
  },
  mixins: [checkStatus],
  mounted() {
  },
  methods: {
    nextStep() {
      const { orderId } = this.$route.query;
      this.$loading.show();
      this.$api.CommonForms.nextJumpPageServer({
        orderId: orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        this.$loading.hide();
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          Toast(res.returnMessage);
        }
      });
    },
    showPositiveImage(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const file = files[0]; // File对象
      this.idFrontPic = file;
      if (this.validate_img(files[0])) {
        // eslint-disable-next-line prefer-destructuring
        self.uploadFile = files[0];
        const reader = new FileReader(); // FileReader对象
        reader.readAsDataURL(files[0]); // 该方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成（DONE），并触发 loadend 事件，同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
        reader.onload = (item) => {
          self.positive = item.target.result; // 图片内容的base64编码
          // 检查是否正反面都已上传，如果是则调用 submit 方法
          if (self.positive && self.negative) {
            self.submit();
          }
        };
      }
    },
    showNegativeImage(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const file = files[0]; // File对象
      this.idBackPic = file;
      if (this.validate_img(files[0])) {
        // eslint-disable-next-line prefer-destructuring
        self.uploadFile = files[0];
        const reader = new FileReader(); // FileReader对象
        reader.readAsDataURL(files[0]); // 该方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成（DONE），并触发 loadend 事件，同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
        reader.onload = (item) => {
          self.negative = item.target.result; // 图片内容的base64编码
          // 检查是否正反面都已上传，如果是则调用 submit 方法
          if (self.positive && self.negative) {
            self.submit();
          }
        };
      }
    },
    validate_img(file) {
      if (!/.(jpg|png|jpeg)$/i.test(file.name)) {
        Toast('请上传正确格式的个人头像');
        return false;
      }
      if (file.size.toFixed(5) >= 10 * 1024 * 1024) {
        Toast('请上传小于10M的图片');
        return false;
      }
      return true;
    },
    submit() {
      if(this.isDisabled) return;
      if (!this.positive) {
        Toast('请上传身份证人像面的图片');
        return;
      }
      if (!this.negative) {
        Toast('请上传身份证国徽面');
        return;
      }
      if (this.positive && this.negative) {
        this.$toast.loading({
          message: '加载中...',
          clear: true,
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
        });
        this.isDisabled = true;
        const { orderId } = this.$route.query;
        const form = new FormData();
        form.append('orderId', orderId || localStorage.getItem('orderId'));
        form.append('idFrontPic', this.idFrontPic);
        form.append('idBackPic', this.idBackPic);
        service.CommonForms.checkIdentityPicService(form).then((res) => {
          this.infoObj = {}
          if (res.success) {
            this.isDisabled = false;
            this.getInfo();
          } else {
            this.$toast.clear();
            this.isDisabled = false;
            Toast(res.returnMessage || '上传失败');
          }
        }).catch((err) => {
          this.$toast.clear();
          this.isDisabled = false;
          this.$toast.fail({
            message: '网络异常，请稍后再试！',
            forbidClick: true,
            duration: 2500,
          });
        });
      }
    },
    getInfo() {
      const { orderId } = this.$route.query;
      service.CommonForms.ocrByAggsOrderId({ aggsOrderId: orderId }).then((res) => {
        this.$toast.clear();
        if (res.success) {
          this.infoObj = res.data;
        }else{
          Toast(res.returnMessage || '获取失败');
        }
      })
    }
    
  },

  computed: {
      // 计算属性，检查 infoObj 是否包含所有 infoFields 对应的有效值
      allFieldsFilled() {
        return this.infoFields.every((item) => {
          const value = this.infoObj[item.label];
          return value !== undefined && value !== null && value !== '';
        });
      },
    },
    watch: {
      // 监听 infoObj 的变化，更新按钮状态
      infoObj: {
        handler() {
          this.btnDisabled = !this.allFieldsFilled;
        },
        deep: true,
      },
    },
};
</script>
<style lang="scss" scoped>
/* 身份认证 */
.content {
  padding-bottom: 76px;
  .top {
    background: #FFFFFF;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    padding: 16px 24px;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.04);
    .upload-item+.upload-item{
      margin-left: 14px;
    }
    .upload-item {
      max-width: 200px;
      flex: 1;
      padding: 12px;
      border: 1px dashed rgba(224,224,224,1);
      border-radius: 8px;
      position: relative;
      .input {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      .tip{
        font-size: 14px;
        color: #FF6538;
        text-align: center;
      }
      .pic{
        width: 100%;
        img{
          width: 100%;
          height: auto;
          margin-bottom: 8px;
        }
      }
    }
  }
  .info{
    text-align: left;
    
  }
  .fix-btm{
    width: 100%;
    padding: 8px 0;
    background: #FFFFFF;
    position: fixed;
    bottom: 0;
  }
}
::v-deep .van-cell__value{
  text-align: left;
}
::v-deep .van-cell__title{
  flex: 0 1 auto;
  width: 100px;
}
</style>
